import React from 'react';
import BaseReportPage from '../../../components/reports/BaseReportPage';

const ProductSalesReport = () => {
  const columns = [
    {
      key: 'productName',
      label: 'Product',
      type: 'text'
    },
    {
      key: 'category',
      label: 'Category',
      type: 'text'
    },
    {
      key: 'unitsSold',
      label: 'Units Sold',
      type: 'number'
    },
    {
      key: 'unitPrice',
      label: 'Unit Price',
      type: 'currency'
    },
    {
      key: 'totalRevenue',
      label: 'Total Revenue',
      type: 'currency'
    },
    {
      key: 'totalCost',
      label: 'Total Cost',
      type: 'currency'
    },
    {
      key: 'profit',
      label: 'Profit',
      type: 'currency'
    },
    {
      key: 'profitMargin',
      label: 'Profit Margin %',
      type: 'percentage'
    },
    {
      key: 'lastSaleDate',
      label: 'Last Sale',
      type: 'date'
    }
  ];

  return (
    <BaseReportPage
      title="Product Sales Report"
      description="Detailed analysis of individual product sales performance"
      reportType="productSales"
      columns={columns}
    />
  );
};

export default ProductSalesReport;